import { useState } from 'react';

import { notificationsApi } from '../../../api/notifications.js';
import { usePaginatedQuery } from '../../../hooks/usePaginatedQuery.js';
import { DataTable } from '../../../components/DataTable.jsx';
import { Pagination } from '../../../components/ui/Pagination.jsx';
import { Badge } from '../../../components/ui/Badge.jsx';
import { Select } from '../../../components/ui/Select.jsx';
import { fmt } from '../../../lib/formatters.js';

const STATUS_TONE = { sent: 'success', failed: 'danger', skipped: 'neutral' };
const STATUS_LABEL = { sent: 'Inviata', failed: 'Fallita', skipped: 'Saltata' };
const SKIP_LABEL = {
  disabled: 'regola disattiva',
  throttled: 'anti-spam',
  no_recipients: 'nessun destinatario',
  no_config: 'config mancante',
  no_template: 'template mancante'
};

export function LogsTab() {
  const { items, isLoading, pagination, setPage, setFilters } = usePaginatedQuery({
    key: ['notifications', 'logs'],
    fetcher: notificationsApi.listLogs
  });
  const [status, setStatus] = useState('');

  const columns = [
    { key: 'createdAt', header: 'Quando', render: (r) => <span className="text-xs text-ink-muted">{fmt.dateTime(r.createdAt)}</span> },
    { key: 'eventKey', header: 'Evento', render: (r) => <code className="text-xs">{r.eventKey}</code> },
    { key: 'status', header: 'Esito', render: (r) => (
      <span className="flex items-center gap-1.5">
        <Badge tone={STATUS_TONE[r.status] || 'neutral'}>{STATUS_LABEL[r.status] || r.status}</Badge>
        {r.skipReason && <span className="text-xs text-ink-muted">{SKIP_LABEL[r.skipReason] || r.skipReason}</span>}
      </span>
    ) },
    { key: 'to', header: 'Destinatari', render: (r) => <span className="text-xs text-ink-muted">{(r.to || []).join(', ') || '-'}</span> },
    { key: 'subject', header: 'Oggetto', render: (r) => <span className="text-xs">{r.subject || '-'}</span> },
    { key: 'error', header: 'Errore', render: (r) => r.error ? <span className="text-xs text-danger">{r.error}</span> : '-' }
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-end gap-3 rounded-xl border border-border bg-surface-elevated p-4">
        <Select label="Esito" className="w-44" value={status} onChange={(e) => { setStatus(e.target.value); setFilters({ status: e.target.value || undefined }); }}>
          <option value="">Tutti</option>
          <option value="sent">Inviata</option>
          <option value="failed">Fallita</option>
          <option value="skipped">Saltata</option>
        </Select>
      </div>
      <DataTable columns={columns} rows={items} loading={isLoading} empty={{ title: 'Nessun invio registrato', description: 'Gli invii e i tentativi appariranno qui.' }} />
      <Pagination pagination={pagination} onPageChange={setPage} />
    </div>
  );
}
